// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/seatbelt-requirements.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/seatbelt-requirements/seatbelt-requirements.js';

mount([g0]);
